﻿import {FormattableString} from "../FormattableString";
import IMessageTranslator from "./IMessageTranslator";
import IStringFormatter from "./IStringFormatter";

export default class TranslatorStringFormatter implements IStringFormatter {
	_messageTranslator: IMessageTranslator;
	_sf: IStringFormatter;

	constructor(translator: IMessageTranslator, stringFormatter: IStringFormatter) {
		this._messageTranslator = translator;
		this._sf = stringFormatter;
	}

	format(message: FormattableString): string;
	format(message: string, args?: Record<string, any> | null | undefined): string;
	format(message: FormattableString | string, args?: Record<string, any> | null | undefined): string {
		if (message == null) {
			return "";
		}

		let text: string;
		let params: Record<string, any> | null | undefined;

		if (typeof message === "string") {
			text = message;
			params = args as Record<string, any> | null;
		} else {
			text = (message as FormattableString).text;
			params = (message as FormattableString).args;
		}

		return this._sf.format(this._messageTranslator.get(text), params);
	}
}
